module.exports = __webpack_public_path__ + "static/media/icon-plus3.b16a2f2f.svg";